import {useFloatingTree} from '@floating-ui/react'
import {DropdownItemLayout} from '../dropdown_item_layout'
import {CosmeticCheckbox} from '~/components/checkbox'

export const DropdownItem = ({onClick, checkbox, keepDropdownOpenAfterClick = checkbox, checked, ...rest}) => {
	const tree = useFloatingTree()

	const handleClick = event => {
		onClick?.(event)
		!keepDropdownOpenAfterClick && tree?.events.emit('click')
	}

	const props = {
		...rest,
		onClick: handleClick,
	}

	if (checkbox)
		return <DropdownItemLayout {...props} leftElement={<CosmeticCheckbox checked={checked} disabled={Boolean(rest.disabled)} />} />

	return <DropdownItemLayout {...props} />
}
